var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "treatments-card",
      attrs: { "aria-label": _vm.treatment.title },
    },
    [
      _c("div", { staticClass: "treatments-card-wrapper" }, [
        _c("div", { staticClass: "treatments-card-content" }, [
          _c("div", { staticClass: "treatments-card-info" }, [
            _c("h3", { staticClass: "treatments-card-title" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.treatment.title) + "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "treatments-card-desc" }, [
              _c("p", {
                staticClass: "desc-wrapper",
                attrs: { id: "desc-" + _vm.treatment.spaSoftId },
                domProps: { innerHTML: _vm._s(_vm.truncatedDescription) },
              }),
              _vm._v(" "),
              _vm.isDescriptionTruncated
                ? _c(
                    "button",
                    {
                      staticClass: "toggle-button",
                      class: {
                        more: !_vm.showFullDescription,
                        less: _vm.showFullDescription,
                      },
                      attrs: {
                        type: "button",
                        "aria-expanded": _vm.showFullDescription,
                        "aria-controls": "desc-" + _vm.treatment.spaSoftId,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.toggleDescriptionVisibility($event)
                        },
                        keydown: [
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.toggleDescriptionVisibility($event)
                          },
                          function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "space", 32, $event.key, [
                                " ",
                                "Spacebar",
                              ])
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.toggleDescriptionVisibility($event)
                          },
                        ],
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.showFullDescription
                              ? _vm.tc("spaSoft.step1.treatmentCards.seeLess")
                              : _vm.tc("spaSoft.step1.treatmentCards.seeMore")
                          ) +
                          "\n          "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "schedule-list", attrs: { role: "radiogroup" } },
          _vm._l(
            _vm.treatment.propertyFacilitySpaTreatmentsVariantModel,
            function (variant, key) {
              return _c(
                "label",
                {
                  key: "time-" + key,
                  staticClass: "schedule-item",
                  attrs: {
                    for:
                      variant.spaSoftId +
                      "-time-guest-" +
                      _vm.currentGuestNumber,
                  },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.treatment
                            .propertyFacilitySpaTreatmentsVariantModel.length >
                          1,
                        expression:
                          "treatment.propertyFacilitySpaTreatmentsVariantModel.length > 1",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedTimeSlot,
                        expression: "selectedTimeSlot",
                      },
                    ],
                    attrs: {
                      id:
                        variant.spaSoftId +
                        "-time-guest-" +
                        _vm.currentGuestNumber,
                      type: "radio",
                      name: "timeslot-" + _vm.treatment.id,
                    },
                    domProps: {
                      value: variant,
                      checked: _vm._q(_vm.selectedTimeSlot, variant),
                    },
                    on: {
                      change: function ($event) {
                        _vm.selectedTimeSlot = variant
                      },
                    },
                  }),
                  _vm._v(" "),
                  variant.duration
                    ? _c(
                        "div",
                        {
                          staticClass: "duration",
                          attrs: {
                            "aria-description": _vm.tc(
                              "spaSoft.step1.treatmentCards.ariaLabelDuration"
                            ),
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(variant.duration) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  variant.dayAndTime
                    ? _c(
                        "div",
                        {
                          staticClass: "time",
                          attrs: {
                            "aria-description": _vm.tc(
                              "spaSoft.step1.treatmentCards.ariaLabelDayAndTime"
                            ),
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(variant.dayAndTime) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  variant.apiTreatmentDetails.price.totalCalculated
                    ? _c(
                        "div",
                        {
                          staticClass: "price",
                          attrs: {
                            "aria-description": _vm.tc(
                              "spaSoft.step1.treatmentCards.ariaLabelPrice"
                            ),
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.getTreatmentPriceFormatted({
                                  treatment: variant,
                                  checkTaxes: true,
                                })
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            }
          ),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "treatments-card-ctas" },
        [
          _vm.treatment.notBookableOnline
            ? _c("contact-modal", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var activate = ref.activate
                        return _c("div", {}, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button--secondary black size-sm outlined",
                              attrs: {
                                "aria-label": _vm.tc(
                                  "spaSoft.step1.treatmentCards.ariaLabelContactCta",
                                  { treatmentTitle: _vm.treatment.title }
                                ),
                              },
                              on: {
                                click: activate,
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return activate($event)
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return activate($event)
                                  },
                                ],
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.tc(
                                      "spaSoft.step1.treatmentCards.contactCta"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ])
                      },
                    },
                  ],
                  null,
                  false,
                  3633703378
                ),
              })
            : _c(
                "button",
                {
                  staticClass: "button--primary black size-sm primary",
                  attrs: {
                    disabled: _vm.addCtaIsDisabled,
                    "aria-label": _vm.tc(
                      "spaSoft.step1.treatmentCards.ariaLabelAddCta",
                      {
                        treatmentTitle: _vm.treatment.title,
                        guestNumber: Number(_vm.currentGuestNumber) + 1,
                      }
                    ),
                  },
                  on: {
                    click: _vm.handleAddClick,
                    keypress: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.handleAddClick($event)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.handleAddClick($event)
                      },
                    ],
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.tc("spaSoft.step1.treatmentCards.addCta")) +
                      "\n    "
                  ),
                ]
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }